import { useState } from 'react';
import { EventContentArg } from '@fullcalendar/core';
import clsx from 'clsx';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
  Typography,
} from '@la/ds-ui-components';
import { ActivityState } from '@la/types/models';
import { isGameActivity } from 'lib/utils/schedules/isGameActivity';
import styles from './SiteLevelCalendar.module.scss';
import { SiteLevelCalendarActivityDetails } from './SiteLevelCalendarActivityDetails/SiteLevelCalendarActivityDetails';
import { useColorClassName } from './utils/useColorClassName';

type SiteLevelCalendarEventContentProps = {
  content: EventContentArg;
  selectedColorFilter: 'program' | 'type';
};

export default function SiteLevelCalendarEventContent({
  content,
  selectedColorFilter,
}: SiteLevelCalendarEventContentProps) {
  const { event, timeText } = content;
  const activity = event.extendedProps?.activity;
  const programId = activity?.programId;
  const type = activity?.type;
  const state = activity?.state;

  const { colorName } = useColorClassName(programId);
  const programColor = `color-${colorName}`;

  const isGame = isGameActivity(type);
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const canceled = state === ActivityState.Canceled;

  const eventClass = clsx({
    [styles.eventTitle]: true,
    [styles.activityTile]: !isGame,
    [styles.gameTile]: isGame,
    [styles.canceled]: canceled,
    [styles[programColor]]: selectedColorFilter === 'program' && !canceled,
  });

  const portalContainer = document.querySelector(
    '#siteCalendar'
  ) as HTMLElement;

  return (
    <>
      {activity ? (
        <Popover open={isPopoverOpen}>
          <PopoverTrigger>
            <div
              className={eventClass}
              onClick={() => setIsPopoverOpen(true)}
              onKeyDown={() => setIsPopoverOpen(true)}
            >
              <Typography variant="ui" size="xs">
                {event.title}
              </Typography>
              <Typography variant="ui" size="xs" weight="bold">
                {timeText}
              </Typography>
            </div>
          </PopoverTrigger>
          <PopoverContent
            arrow={false}
            avoidCollisions
            hideWhenDetached
            width={250}
            sideOffset={-150}
            data-side="bottom"
            portalContainer={portalContainer}
            onInteractOutside={() => setIsPopoverOpen(false)}
          >
            <SiteLevelCalendarActivityDetails
              activity={activity}
              togglePopover={setIsPopoverOpen}
            />
          </PopoverContent>
        </Popover>
      ) : null}
    </>
  );
}
